// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2srRa","label":"styles_label__1YP7r"};